import PropTypes from "prop-types";

const Learn_More_Frame = ({ className = "" }) => {
  return (
    <div
      className={`shadow-[0px_10px_6.8px_rgba(0,_0,_0,_0.25)] rounded-11xl bg-gray-400 flex flex-col p-6 box-border text-left text-3xl text-gray-100 font-istok-web ${className}`}
    >
      <ul className="space-y-4 text-blue-900 text-sm">
        <li>
          <span className="font-bold">Expertise Across Industries:</span> With
          our years of experience and a vast network, we are well-versed in
          recruiting talent for a wide range of industries.
        </li>
        <li>
          <span className="font-bold">Tailored Solutions:</span> We don't
          believe in a one-size-fits-all approach. Every client's needs are
          different, and we work closely with you to create customized solutions
          that address your unique requirements.
        </li>
        <li>
          <span className="font-bold">Access to Top Talent:</span> Our extensive
          database, coupled with proactive sourcing techniques, gives us access
          to the best talent in the market – ensuring that you get only the most
          qualified candidates.
        </li>
        <li>
          <span className="font-bold">Streamlined Process:</span> We use
          innovative recruitment tools and strategies to make the hiring process
          efficient, saving you time and resources.
        </li>
        <li>
          <span className="font-bold">Client Satisfaction:</span> Our goal is to
          build lasting relations with our clients, offering supreme customer
          service and a results-driven approach.
        </li>
      </ul>
    </div>
  );
};

Learn_More_Frame.propTypes = {
  className: PropTypes.string,
};

export default Learn_More_Frame;
